import { Injectable } from '@nestjs/common';
import { Repository, Raw, getConnection } from 'typeorm';
import { InjectRepository } from '@nestjs/typeorm';
import { ErrorResponse } from '@gtpl/shared-models/common-models';
import {ExpensesSubCategory} from './expenses-sub-category.entity';
import {ExpensesSubCategoryDTO} from './dto/expenses-sub-category.dto';
import {ExpensesSubCategoryAdapter} from './dto/expenses-sub-category.adapter';
import { ExpensesSubCategoryResponse, AllExpensesSubCategoryResponse } from '@gtpl/shared-models/hrms';
import { ExpensesSubCategoryRequest } from './dto/expenses-sub-category.request';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';

@Injectable()
export class ExpensesSubCategoryService {

    constructor(
      private logService:LogsService,

        @InjectRepository(ExpensesSubCategory)
        private expensesSubCategoryRepository: Repository<ExpensesSubCategory>,
        private Adapter: ExpensesSubCategoryAdapter,
    ){}
    /**
     * get expensesSubCategory details
     * @param expensesSubCategory 
     */
    // @LogActions({isAsync: true})
    async getExpensesSubCategoryDetailsWithoutRelations(expensesSubCategory: string): Promise<ExpensesSubCategory> {
        // tslint:disable-next-line: typedef
        const expensesSubCategoryResponse = await this.expensesSubCategoryRepository.findOne({
          where: {expensesSubCategory: Raw(alias => `expenses_sub_category = '${expensesSubCategory}'`)},
         
        });
        if (expensesSubCategoryResponse) {
          return expensesSubCategoryResponse;
        } else {
          return null;
        }
      }

      async createExpensesSubCategory(expensesSubCategoryDto: ExpensesSubCategoryDTO, isUpdate: boolean): Promise<ExpensesSubCategoryResponse> {
        // console.log(statesDto);
        try {
          // to check whether State exists with the passed  State code or not. if isUpdate is false, a check will be done whether a record with the passed Statecode is existing or not. if a record exists then a return message wil be send with out saving the data.  if record is not existing with the passed State code then a new record will be created. if isUpdate is true, then no check will be performed and  record will be updated(if record exists with the passed cluster code) or created.
          if (!isUpdate) {
            const expensesSubCategoryEntity = await this.getExpensesSubCategoryDetailsWithoutRelations(expensesSubCategoryDto.expensesSubCategory);
            if (expensesSubCategoryEntity) {
              //return new InformationMessageError(11104, "State already exists");
              throw new ErrorResponse(11104, 'Expenses Sub Category already exists');
            }
          }
          else{
            const expensesSubCategoryEntity = await this.getExpensesSubCategoryDetailsWithoutRelations(expensesSubCategoryDto.expensesSubCategory);
            if (expensesSubCategoryEntity) {
              if(expensesSubCategoryEntity.expensesSubCategoryId!=expensesSubCategoryDto.expensesSubCategoryId) {
                throw new ErrorResponse(11104, 'Expenses Sub Category already exists');      
            }
              //return new InformationMessageError(11104, "State already exists");
            }
          }
          const convertedExpensesSubCategoryEntity: ExpensesSubCategory = this.Adapter.convertDtoToEntity(expensesSubCategoryDto,isUpdate);
          const savedExpensesSubCategoryEntity: ExpensesSubCategory = await this.expensesSubCategoryRepository.save(
            convertedExpensesSubCategoryEntity
          );
          const savedExpensesSubCategoryDto: ExpensesSubCategoryDTO = this.Adapter.convertEntityToDto(convertedExpensesSubCategoryEntity);
            // console.log(savedStateDto);
          if (savedExpensesSubCategoryDto) {
            // generating resposnse
            const response = new ExpensesSubCategoryResponse(true,1,isUpdate? 'Expenses Sub Category Updated Successfully': 'Expenses Sub Category Created Successfully')
            const name=isUpdate?'updated':'created'
            
            const newLogDto = new LogsDto(1,name, 'ExpensesSubCategory', savedExpensesSubCategoryDto.expensesSubCategoryId, true, '',savedExpensesSubCategoryDto.createdUser)
            let res = await this.logService.createLog(newLogDto);
            console.log(res);
            return response
          } else {
            //return new InformationMessageError(11106, "State saved but issue while transforming into DTO");
            throw new ErrorResponse(11106,'Expenses Sub Category saved but issue while transforming into DTO');
          }
        } catch (error) {
          // when error occures while saving the data , the execution will come to catch block.
          // tslint:disable-next-line: typedef
          throw error;
        }
      }  

      async getAllExpensesSubCategories(): Promise<AllExpensesSubCategoryResponse> {
        // const page: number = 1;
        
        try {
          const ExpensesSubCategoryDtos: ExpensesSubCategoryDTO[] = [];
          //retrieves all companies
          const ExpensesSubCategoryEntities: ExpensesSubCategory[] = await this.expensesSubCategoryRepository.find({order :{'createdAt':'DESC'},relations: ['expensesCategoryInfo']});
          //console.log(statesEntities);
          if (ExpensesSubCategoryEntities) {
            // converts the data fetched from the database which of type companies array to type StateDto array.
            ExpensesSubCategoryEntities.forEach(ExpensesSubCategoryEntity => {
              const convertedExpensesSubCategoryDto: ExpensesSubCategoryDTO = this.Adapter.convertEntityToDto(
                ExpensesSubCategoryEntity
              );
              ExpensesSubCategoryDtos.push(convertedExpensesSubCategoryDto);
            });
            const response = new AllExpensesSubCategoryResponse(true,1,'Expenses Sub Category retrieved successfully',ExpensesSubCategoryDtos);
            //generated response
            const newLogDto = new LogsDto(1,'view', 'ExpensesSubCategory', 0, true, '','')
            let res = await this.logService.createLog(newLogDto);
            console.log(res);
            return response
          } else {
            throw new ErrorResponse(99998, 'Data not found');
          }
        
        } catch (err) {
          throw err;
        }
      }
      async getAllActiveExpensesSubCategories(): Promise<AllExpensesSubCategoryResponse> {
        // const page: number = 1;
        try {
            const expensesSubCategoryDto: ExpensesSubCategoryDTO[] = [];
            //retrieves all expenses Sub Categories
            const ExpensesSubCategoryEntities: ExpensesSubCategory[] = await this.expensesSubCategoryRepository.find({ order: { 'expensesSubCategory': 'ASC' },where:{isActive:true},
           });
         console.log(ExpensesSubCategoryEntities)
            if (ExpensesSubCategoryEntities) {
                // converts the data fetched from the database which of type companies array to type StateDto array.
                ExpensesSubCategoryEntities.forEach(expensesSubCategoryEntity => {
                    const convertedExpensesSubCategoryDto: ExpensesSubCategoryDTO = this.Adapter.convertEntityToDto(
                      expensesSubCategoryEntity
                      
                    );
                    expensesSubCategoryDto.push(convertedExpensesSubCategoryDto);
                });
                const response = new AllExpensesSubCategoryResponse(true, 11108, "ExpensesSubCategory retrieved successfully", expensesSubCategoryDto);
                return response;
            } else {
                throw new ErrorResponse(99998, 'Data not found'); expensesSubCategoryDto
            }
        } catch (err) {
            throw err;
        }
    }
      async activateOrDeactivateExpensesSubCategory(expensesSubCategoryReq: ExpensesSubCategoryRequest): Promise<ExpensesSubCategoryResponse> {
        try {
            const expensesSubCategoryExists = await this.getExpensesSubCategoryById(expensesSubCategoryReq.expensesSubCategoryId);
            if (expensesSubCategoryExists) {
                if (expensesSubCategoryReq.versionFlag !== expensesSubCategoryExists.versionFlag) {
                    throw new ErrorResponse(10113, 'Someone updated the current Expenses Sub category information.Refresh and try again');
                } else {
                    
                        const expensesSubCategoryStatus =  await this.expensesSubCategoryRepository.update(
                            { expensesSubCategoryId: expensesSubCategoryReq.expensesSubCategoryId },
                            { isActive: expensesSubCategoryReq.isActive,updatedUser: expensesSubCategoryReq.updatedUser });
                       
                        if (expensesSubCategoryExists.isActive) {
                            if (expensesSubCategoryStatus.affected) {
                                const expensesSubCategoryResponse: ExpensesSubCategoryResponse = new ExpensesSubCategoryResponse(true, 10115, 'ExpensesSubCategory is de-activated successfully');
                                return expensesSubCategoryResponse;
                            } else {
                                throw new ErrorResponse(10111, 'ExpensesSubCategory is already deactivated');
                            }
                        } else {
                            if (expensesSubCategoryStatus.affected) {
                                const expensesSubCategoryResponse: ExpensesSubCategoryResponse = new ExpensesSubCategoryResponse(true, 10114, 'ExpensesSubCategory is activated successfully');
                                return expensesSubCategoryResponse;
                            } else {
                                throw new ErrorResponse(10112, 'ExpensesSubCategory is already  activated');
                            }
                        }
                    // }
                }
            } else {
                throw new ErrorResponse(99998, 'No Records Found');
            }
        } catch (err) {
            throw err;
        }
    }
      async getActiveExpensesSubCategoryById(expensesSubCategoryReq: ExpensesSubCategoryRequest): Promise<ExpensesSubCategoryResponse> {
        try {
          //retrieves all companies
          const ExpensesSubCategoryEntities: ExpensesSubCategory = await this.expensesSubCategoryRepository.findOne({
              where:{expensesSubCategoryId:expensesSubCategoryReq.expensesSubCategoryId}
              });
              
              const expensesSubCategoryData: ExpensesSubCategoryDTO = this.Adapter.convertEntityToDto(ExpensesSubCategoryEntities);
              if (expensesSubCategoryData) {
                  const response = new ExpensesSubCategoryResponse(true, 11101 , 'ExpensesSubCategory retrived Successfully',expensesSubCategoryData);
                  return response;
              }
              else{
                  throw new ErrorResponse(11106,'Something went wrong');
              }
              // generating resposnse
      } catch (err) {
          throw err;
      }
    }

    async getExpensesSubCategoryById(expensesSubCategoryId: number): Promise<ExpensesSubCategory> {
        //  console.log(employeeId);
            const Response = await this.expensesSubCategoryRepository.findOne({
            where: {expensesSubCategoryId: expensesSubCategoryId},
            relations: ['expensesCategoryInfo']
            });
            // console.log(employeeResponse);
            if (Response) {
            return Response;
            } else {
            return null;
            }
        }
}
